// extracted by mini-css-extract-plugin
export default {"root":"Burger_root-chy","icon":"Burger_icon-X4f"};